// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iqvia-formerly-quin {
  font-size: 16px;
  width: 100%;
  resize: none;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.image-upload-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.upload-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.progress-container {
  width: 100%;
}

.upload-progress {
  background: #e9ecef;
  height: 4px;
  border-radius: 2px;
  overflow: hidden;
}

.progress-bar {
  background: #007bff;
  height: 100%;
  transition: width 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/admin-site-configuration/admin-site-configuration.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B","sourcesContent":[".iqvia-formerly-quin {\r\n  font-size: 16px;\r\n  width: 100%;\r\n  resize: none;\r\n  padding: 1rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n}\r\n\r\n.image-upload-section {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.upload-section-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.progress-container {\r\n  width: 100%;\r\n}\r\n\r\n.upload-progress {\r\n  background: #e9ecef;\r\n  height: 4px;\r\n  border-radius: 2px;\r\n  overflow: hidden;\r\n}\r\n\r\n.progress-bar {\r\n  background: #007bff;\r\n  height: 100%;\r\n  transition: width 0.3s ease;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
